var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.5C2 9.66344 9.16344 2.5 18 2.5C26.8366 2.5 34 9.66344 34 18.5C34 27.3366 26.8366 34.5 18 34.5C9.16344 34.5 2 27.3366 2 18.5ZM4 18.5C4 10.768 10.268 4.5 18 4.5C25.732 4.5 32 10.768 32 18.5C32 26.232 25.732 32.5 18 32.5C10.268 32.5 4 26.232 4 18.5ZM19.0068 26.127C19.0068 26.7949 18.5586 27.2432 17.9082 27.2432C17.2578 27.2432 16.8184 26.7949 16.8184 26.127V15.7119L16.8887 13.8047L14.8057 16.1602L12.8281 18.1289C12.626 18.3223 12.3623 18.4541 12.0459 18.4541C11.4482 18.4541 11 18.0146 11 17.3994C11 17.1094 11.1143 16.8369 11.3428 16.6084L17.0996 10.8428C17.3105 10.623 17.6094 10.5 17.9082 10.5C18.207 10.5 18.5146 10.623 18.7256 10.8428L24.4824 16.6084C24.7109 16.8369 24.8252 17.1094 24.8252 17.3994C24.8252 18.0146 24.377 18.4541 23.7793 18.4541C23.4629 18.4541 23.1992 18.3223 22.9971 18.1289L21.0107 16.1602L18.9277 13.8047L19.0068 15.7119V26.127Z",
    fill: "#DFDFDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.48a218ae.svg";
export { ForwardRef as ReactComponent };